<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Pendaftaran Embrio IBVK" >
      <w-card bg-color="" class="">
        <div class="w-flex wrap smd-column" >
          <div class="mx2"></div>
          <div class="grow ">
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                <table >
                  <tbody>
                    <tr>
                      <td>
                        <div class="grow ">
                          <figure class="qrcode">
                            <vue-qrcode :value="'se/'+data.id" width="200"/>
                            <img class="qrcode__image" src="/images/logog.png"   alt="Chen Fengyuan"   />
                          </figure>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="grow ">
                <table >
                  <tbody>
                  <tr class="row_data">
                     <td><b>Tarikh Pendaftaran</b></td>
                     <td><b>:</b></td>
                     <td>{{ $zutil.dateformat(data.tarikh)}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nombor Batch</b></td>
                     <td><b>:</b></td>
                     <td>{{data.no_batch}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>ID Ternakan Jantan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.id_ternakan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nama Ternakan Jantan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_ternakan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Baka Jantan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.baka}}</td>
                  </tr>
                  
                  <tr class="row_data">
                     <td><b>Negara</b></td>
                     <td><b>:</b></td>
                     <td>{{data.negara}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Harga Perstraw (RM)</b></td>
                     <td><b>:</b></td>
                     <td>{{data.harga}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
                <table >
                  <tbody>
                  <tr class="row_data">
                     <td><b>Tarikh Pengeluaran</b></td>
                     <td><b>:</b></td>
                     <td>{{$zutil.dateformat(data.tarikh_pengeluaran)}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>ID Ternakan Penderma</b></td>
                     <td><b>:</b></td>
                     <td>{{data.id_ternakan_penderma}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nama Ternakan Penderma</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_penderma_ternakan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Baka Penderma</b></td>
                     <td><b>:</b></td>
                     <td>{{data.penderma_baka}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Bilangan Straw</b></td>
                     <td><b>:</b></td>
                     <td>{{data.bil_straw}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Bilangan Terpakai</b></td>
                     <td><b>:</b></td>
                     <td>{{data.terpakai}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Baki Straw</b></td>
                     <td><b>:</b></td>
                     <td>{{data.baki}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Generasi</b></td>
                     <td><b>:</b></td>
                     <td>{{data.gred}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Stage</b></td>
                     <td><b>:</b></td>
                     <td>{{data.stage}}</td>
                  </tr>
                  </tbody>
                </table>
                
              </div>
            </div>
          </div>
        </div>
      </w-card>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import VueQrcode from 'vue-qrcode'
// import Pengambilan from './Show/Pengambilan.vue';

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide, VueQrcode
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'embrio.pendaftaran',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Embrio Beku', route: '/embrio' },
        { label: 'Pendaftaran Embrio IBVK', route: '/embrio/pendaftaran' },
        { label: 'Papar', route: '/embrio/pendaftaran/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      tabs: [
            { title: 'Pengeluaran', content: '' },
          ]
    }
  },
  methods: {
    getData()
    {
      this.$zcomm.get(this.api_service + 'se_pendaftaran/show/'+this.id, {}).then(res => {
        this.data = res
        // this.getAttahecment()
        // this.listTabs()
      })

    },
    tutup(){
      this.$inertia.visit(window.route('embrio.pendaftaran.index'));
    },
    kemaskini(){
      this.$inertia.visit(window.route('embrio.pendaftaran.from', this.id));
    },

   
   

  },
  watch: {

  },
  mounted() {
    this.getData();
  },
}
</script>
<style scoped>
.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
  margin-top: -12px;
}

.qrcode__image {
  background-color: #fff;
  border: 0.25rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 15%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15%;
}

table {
     width: 100%;
     border-collapse: collapse;
   }

   .row_data td {
     padding: 6px 4px;   
     font-size: 14px;
     color: #333;
   }


   .row_data td:first-child {
     width: 220px;         
     padding-right: 10px;
     font-weight: 600;
   }


   .row_data td:nth-child(2) {
     width: 15px;
     text-align: center;
     font-weight: bold;
   }


   .row_data td:last-child {
     font-weight: 500;
   }


   .w-flex table {
     margin-bottom: 12px;
   }

   
   .table-status td:first-child {
     width: 120px !important;     /* sebelum 190px → jadi 120px */
     padding-right: 8px;
     font-weight: 600;
   }

   .table-status td:nth-child(2) {
     width: 12px !important;
     text-align: center;
   }
</style>
